// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"5f6a0fb9","149":"fa369da6","181":"0d47895d","386":"82b321b2","389":"7bd29618","415":"c597beaa","462":"83ccb13c","643":"76bd56df","681":"a19763cb","725":"bd131d2d","796":"275167a9","805":"0583fe45","978":"7557da39"}[chunkId] + ".chunk.js";
};